// TODO: start using this util shared function in other parts of the app
// Default argument for switch statements so TypeScript notifies if we fail to cover a case
export const exhaustiveCheck = (arg: never) => arg;
